<template>
  <div>
    <b-container
      v-show="!isIAPCancelled && !showPremiumSettings"
      class="py-5 custom-container"
      id="subscriptionContainer"
    >
      <b-row align-v="center" class="mt-5 mb-3">
        <b-col class="my-4 py-4 text-center">
          <h2 class="font-weight-bold">Subscription</h2>
        </b-col>
      </b-row>
      <b-row v-if="isTradieUser" align-v="stretch" align-h="around">
        <carousel
          v-if="!isUserSubscribed || hasCanceledOnTrial"
          :paginationEnabled="true"
          :paginationActiveColor="'#969EB0'"
          :scrollPerPage="true"
          :perPage="2"
          :perPageCustom="[
            [320, 1],
            [768, 2]
          ]"
        >
          <slide :class="'col-sm-12 col-md-6 col-lg-6 col-12'">
            <b-card
              class="h-100 mb-4 mx-xl-auto mx-4 px-5 py-4 text-center"
              style="max-width: 550px;"
            >
              <b-card-title>Basic Package</b-card-title>
              <h2 class="my-4 mb-5 text-primary font-weight-bold">Free</h2>
              <b-card-text class="text-left">
                <ul class="subscription-details">
                  <li>User Profile Management</li>
                  <li>
                    Secure Document Management (Upload, Store and Retrieve)
                    Certificates and Documents
                  </li>
                  <li>
                    Automatic Notification for Expiring Documents (Certificates,
                    IDs)
                  </li>
                  <li>
                    Connecting and sharing profiles/documents to up to
                    <span class="text-primary">1</span> Business Admin
                  </li>
                  <li>
                    Quick and secured access through Biometric Authentication
                    for Mobile App
                  </li>
                  <li class="disabled">
                    Quick Document Organisation - Pinning documents for top view
                  </li>
                </ul>
              </b-card-text>
            </b-card>
          </slide>
          <slide :class="'col-sm-12 col-md-6 col-lg-6 col-12'">
            <b-card
              class="h-100 mb-4 mx-xl-auto mx-4 px-5 py-4 text-center"
              style="max-width: 550px;"
            >
              <b-card-title>Premium Package</b-card-title>
              <h2 class="my-4 mb-5 text-primary font-weight-bold">
                <span>
                  $1.99&nbsp;
                  <small
                    class="text-muted"
                    style="display: table-cell; vertical-align: middle;"
                  >
                    <h6
                      style="display: inline; color: #969eb0; font-size: 16px; font-weight: 600;"
                    >
                      /month
                    </h6>
                  </small>
                </span>
              </h2>
              <b-card-text class="text-left">
                <ul class="subscription-details">
                  <li>User Profile Management</li>
                  <li>
                    Secure Document Management (Upload, Store and Retrieve) IDs,
                    Certificates and Documents
                  </li>
                  <li>
                    Automatic Notification for Expiring Documents (Certificates,
                    IDs)
                  </li>
                  <li>
                    Connecting and sharing profiles/documents to up to
                    <span class="text-primary">5</span> Business Admins
                  </li>
                  <li>
                    Quick and secured access through Biometric Authentication
                    for Mobile App
                  </li>
                  <li>
                    Quick Document Organisation - Pinning documents for top view
                  </li>
                </ul>
              </b-card-text>

              <b-button
                :to="{ name: 'premium.subscribe' }"
                variant="primary"
                class="h-auto w-75 py-3 mt-5"
                size="lg"
              >
                {{ hasCanceledOnTrial ? 'Subscribe' : 'Start Free Trial' }}
              </b-button>
            </b-card>
          </slide>
        </carousel>
        <b-col v-else cols="12" lg="6" md="6" sm="12">
          <b-card
            class="h-100 mb-4 mx-xl-auto mx-4 px-5 py-4 text-center"
            style="max-width: 550px;"
          >
            <b-card-title>Premium Package</b-card-title>
            <h2 class="my-4 mb-5 text-primary font-weight-bold">
              <span>
                $1.99&nbsp;
                <small
                  class="text-muted"
                  style="display: table-cell; vertical-align: middle;"
                >
                  <h6
                    style="display: inline; color: #969eb0; font-size: 16px; font-weight: 600;"
                  >
                    /month
                  </h6>
                </small>
              </span>
            </h2>
            <b-card-text class="text-left">
              <ul class="subscription-details">
                <li>User Profile Management</li>
                <li>
                  Secure Document Management (Upload, Store and Retrieve) IDs,
                  Certificates and Documents
                </li>
                <li>
                  Automatic Notification for Expiring Documents (Certificates,
                  IDs)
                </li>
                <li>
                  Connecting and sharing profiles/documents to up to
                  <span class="text-primary">5</span> Business Admins
                </li>
                <li>
                  Quick and secured access through Biometric Authentication for
                  Mobile App
                </li>
                <li>
                  Quick Document Organisation - Pinning documents for top view
                </li>
              </ul>
            </b-card-text>

            <b-button
              variant="primary"
              class="h-auto w-75 py-3 mt-5"
              id="cancelTradieSubcBtn"
              size="lg"
              @click="
                isPlatformStripe
                  ? (cancelModal = true)
                  : (showPremiumSettings = true)
              "
            >
              Cancel Subscription
            </b-button>
          </b-card>
        </b-col>
      </b-row>
      <b-row v-else align-v="stretch" align-h="around">
        <carousel
          v-if="!isUserSubscribed || hasCanceledOnTrial"
          :paginationEnabled="true"
          :paginationActiveColor="'#969EB0'"
          :scrollPerPage="true"
          :perPage="2"
          :perPageCustom="[
            [320, 1],
            [768, 2]
          ]"
        >
          <slide :class="'col-sm-12 col-md-6 col-lg-6 col-12'">
            <b-card
              class="h-100 mb-4 mx-xl-auto mx-4 px-5 py-4 text-center"
              style="max-width: 550px;"
            >
              <b-card-title>Basic Package</b-card-title>
              <h2 class="my-4 mb-5 text-primary font-weight-bold">Free</h2>
              <b-card-text class="text-left">
                <ul class="subscription-details">
                  <li>Request Files and Document from Tradies</li>
                  <li>
                    File Verification Management - Reject or Accept Files
                  </li>
                  <li>
                    Download Backup Copies to Computer (Tradies Certificate)
                  </li>
                  <li>
                    Automatic Notification for Expiring Documents (Certificates,
                    IDs)
                  </li>
                  <li>
                    Tradie Profile Management - Connect up to
                    <span class="text-primary">5</span> Tradies’ Profiles
                  </li>
                  <li>
                    Share up to <span class="text-primary">5</span> Tradie’s
                    Profile to other companies
                  </li>
                  <li>
                    Quick and secured access through Biometric Authentication
                    for Mobile App
                  </li>
                  <li class="disabled">
                    Quick Document Organisation - Pinning documents for top view
                  </li>
                </ul>
              </b-card-text>
            </b-card>
          </slide>
          <slide :class="'col-sm-12 col-md-6 col-lg-6 col-12'">
            <b-card
              class="h-100 mb-4 mx-xl-auto mx-4 px-5 py-4 text-center"
              style="max-width: 550px;"
            >
              <b-card-title>Premium Package</b-card-title>
              <h2 class="my-4 mb-5 text-primary font-weight-bold">
                <span>
                  $9.99&nbsp;
                  <small
                    class="text-muted"
                    style="display: table-cell; vertical-align: middle;"
                  >
                    <h6
                      style="display: inline; color: #969eb0; font-size: 16px; font-weight: 600;"
                    >
                      /month
                    </h6>
                  </small>
                </span>
              </h2>
              <b-card-text class="text-left">
                <ul class="subscription-details">
                  <li>Request Files and Document from Tradies</li>
                  <li>
                    File Verification Management - Reject or Accept Files
                  </li>
                  <li>
                    Download Backup Copies to Computer
                  </li>
                  <li>
                    Automatic Notification for Expiring Documents (Certificates,
                    IDs)
                  </li>
                  <li>
                    Tradie Profile Management - Connect up to
                    <span class="text-primary">50</span> Tradies’ Profiles
                  </li>
                  <li>
                    Share unlimited documents for
                    <span class="text-primary">30</span> Tradies to other
                    companies
                  </li>
                  <li>
                    Quick and secured access through Biometric Authentication
                    for Mobile App
                  </li>
                  <li>
                    Quick Document Organisation - Pinning documents for top view
                  </li>
                </ul>
              </b-card-text>

              <b-button
                :to="{ name: 'premium.subscribe' }"
                variant="primary"
                class="h-auto w-75 py-3 mt-5"
                size="lg"
              >
                {{ hasCanceledOnTrial ? 'Subscribe' : 'Start Free Trial' }}
              </b-button>
            </b-card>
          </slide>
        </carousel>

        <b-col v-else cols="12" lg="6" md="6" sm="12">
          <b-card
            class="h-100 mb-4 mx-xl-auto mx-4 px-5 py-4 text-center"
            style="max-width: 550px;"
          >
            <b-card-title>Premium Package</b-card-title>
            <h2 class="my-4 mb-5 text-primary font-weight-bold">
              <span>
                $9.99&nbsp;
                <small
                  class="text-muted"
                  style="display: table-cell; vertical-align: middle;"
                >
                  <h6
                    style="display: inline; color: #969eb0; font-size: 16px; font-weight: 600;"
                  >
                    /month
                  </h6>
                </small>
              </span>
            </h2>
            <b-card-text class="text-left">
              <ul class="subscription-details">
                <li>Request Files and Document from Tradies</li>
                <li>File Verification Management - Reject or Accept Files</li>
                <li>
                  Download Backup Copies to Computer (Tradies Certificate)
                </li>
                <li>
                  Automatic Notification for Expiring Documents (Certificates,
                  IDs)
                </li>
                <li>
                  Tradie Profile Management - Connect up to
                  <span class="text-primary">50</span> Tradies’ Profiles
                </li>
                <li>
                  Share unlimited documents for
                  <span class="text-primary">30</span> Tradies to other
                  companies
                </li>
                <li>
                  Quick and secured access through Biometric Authentication for
                  Mobile App
                </li>
                <li>
                  Quick Document Organisation - Pinning documents for top view
                </li>
              </ul>
            </b-card-text>

            <b-button
              variant="primary"
              class="h-auto w-75 py-3 mt-5"
              id="cancelBusinessAdminSubcBtn"
              size="lg"
              @click="
                isPlatformStripe
                  ? (cancelModal = true)
                  : (showPremiumSettings = true)
              "
            >
              Cancel Subscription
            </b-button>
          </b-card>
        </b-col>
      </b-row>
    </b-container>

    <b-modal centered v-model="cancelModal" id="cancelModal">
      <template #modal-header>
        <h3>Cancel Subscription</h3>
        <b-button
          pill
          @click="cancelModal = false"
          size="sm"
          variant="white"
          class="px-0 h-25"
        >
          <b-icon icon="x"></b-icon>
        </b-button>
      </template>

      <template #default>
        <p>Are you sure you want to cancel your premium subscription?</p>
      </template>

      <template #modal-footer>
        <b-container fluid>
          <b-row class="justify-content-sm-end justify-content-center">
            <b-col cols="12" sm="5">
              <b-button
                block
                size="lg"
                variant="outline-secondary"
                class="px-4 mr-sm-1"
                :disabled="loading"
                @click="cancelModal = false"
              >
                No, keep it
              </b-button>
            </b-col>
            <b-col cols="12" sm="6">
              <b-button
                block
                size="lg"
                variant="primary"
                class="px-1 ml-sm-1"
                :disabled="loading"
                @click="subscriptionCancel()"
              >
                Yes, cancel
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </b-modal>

    <transition name="fade">
      <subscription-cancel-page
        v-if="isIAPCancelled"
        @redirectToSubscription="redirectToSubscriptionPanel"
      />
      <premium-settings v-else-if="showPremiumSettings" />
    </transition>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import SubscriptionCancelPage from './CancelledPage'
import PremiumSettings from '@/components/PremiumSettings'

export default {
  name: 'SubscriptionPage',

  components: {
    SubscriptionCancelPage,
    PremiumSettings
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    }),

    isTradieUser() {
      return this.user ? this.user.user_type === 'tradie' : false
    },

    isUserSubscribed() {
      return this.user ? this.user.is_subscribed : false
    },

    isUserOnTrial() {
      return this.user ? this.user.subscription_status === 'trialing' : false
    },

    isPlatformStripe() {
      return this.user ? this.user.subscribed_platform === 'stripe' : false
    },

    hasCanceled() {
      return this.user ? this.user.subscription_status === 'canceled' : false
    },

    hasCanceledOnTrial() {
      return this.isUserSubscribed && this.hasCanceled && this.isPlatformStripe
    },

    disableCancelSubc() {
      return this.isUserSubscribed && this.isUserOnTrial
    }
  },

  data() {
    return {
      isIAPCancelled: false,
      cancelModal: false,
      loading: false,
      dismissCountDown: 0,
      alertMsg: null,
      alertType: 'primary',
      showPremiumSettings: false
    }
  },

  methods: {
    ...mapActions({
      cancelSubscription: 'subscription/cancelSubscription',
      getAuthenticatedUser: 'auth/getAuthenticatedUser'
    }),

    async subscriptionCancel() {
      this.loading = true

      await this.cancelSubscription()
        .then(() => {
          this.getAuthenticatedUser().then(() => {
            this.isIAPCancelled = true
          })
        })
        .catch(() => {
          setTimeout(e => {
            this.clearAlert()
          }, 5000)

          this.alertType = 'danger'
          this.alertMsg =
            'Something went wrong while cancelling your account subscription from premium!'
          this.dismissCountDown = 5
        })
        .finally(() => {
          this.loading = false
          this.cancelModal = false
        })
    },

    redirectToSubscriptionPanel() {
      this.isIAPCancelled = false

      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    },

    dlCountDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },

    clearAlert() {
      this.dismissCountDown = 0
      this.alertMsg = null
      this.alertType = 'primary'
    }
  }
}
</script>

<style lang="scss" scoped>
.subscription-details {
  & li.disabled {
    color: #969eb0 !important;

    &:before {
      content: none;
      margin-left: -32px;
      margin-right: 16px;
      transform: scale(1.6);
      display: inline-block;
    }
  }

  li:before {
    content: url('~@/assets/icons/subscription-check.svg');
    margin-left: -32px;
    margin-right: 16px;
    transform: scale(1.6);
    display: inline-block;
  }

  li {
    list-style-type: none;
    margin-bottom: 16px;
  }
}

/deep/ .VueCarousel-slide {
  position: relative;
  display: inline-grid;
}

/deep/ .VueCarousel-dot {
  width: 32px !important;
  border-radius: 25px !important;
}
</style>
